let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kNFvF"), load("4B8pt")]).then(() => parcelRequire('75dcc'));